export type ICartSelection = {
  colour: number
  dimension: number
  foil: number
  height: number
  width: number
  diameter: number
  label_shape: number
  label_type: number
  machine_processing: number
  orientation: number
  paper: number
  quantity: number
  sorts: number
  variation: number
  varnish: number
  winding_direction: number
  core_diameter: number
  die: number
  artwork_service: number
  max_roll_diameter: number
  labels_per_roll: number
  order_name: string
  order_comment: string
  express?: number
  super_express?: number
  neutral_delivery?: number
  additional_file_copies: boolean
  additional_file_copies_delivery_id: number
  quantity_additional_file_copies: number
  add_artwork_service: boolean
  proof?: number
  job_type?: string
  artwork_service_description?: string
  artwork_service_project_name?: string
  transparency: boolean
  upload_completed: boolean
  // Only set when the user picked a currency other than the shop default
  // (e.g. EUR in the UK/GBP shop). Omitted for the shop's default currency,
  // keeping requests backward compatible with APIs that don't support it.
  // The API/DB store this as a numeric id, not a currency code.
  currency_id?: number
}

export type ICartItemDetailsReadable = {
  property: string
  value: string
}

export enum IApiKeysJobType {
  STANDALONE_ARTWORK_SERVICE = 10
}

export type ICartItemPayload = {
  _id: string
  description: string
  quantity: number
  comment: string
  job_type: string
  delivery_address_id: number
  billing_address_id: number
  maschine_id: number
  finishing_maschine_id: string
  smagdie_id: number
  height: number
  width: number
  width_in_inches: number
  height_in_inches: number
  paper_id: number
  gap: number
  foil: number
  colour_value: string
  kunden_id: number
  separate_copies_id: number
  hotfoil_id: number
  varnish_id: number
  roll_diameter: number
  max_labels_roll: number
  winding_direction_id: string
  artwork_service_type_id: string
  proof_type_id: number
  express: number
  express_delivery: number
  super_express: number
  delivery_type_id: number
  payment_type_id: number
  amount_colours: number
  cost_data_check: number
  opaque: string
  price: number
  price_before_extra_cost?: number
  cost_express_production: number
  cost_super_express_production: number
  cost_proof: number
  cost_die: number
  cost_delivery: number
  estimated_express_cost: number
  estimated_neutral_cost: number
  estimated_express_neutral_cost: number
  cost_extra_core_diameter: number
  cost_alternative: number
  cost_additional_file_copies: number
  web_width: number
  discount: number
  colour_type: string
  amount_sorts: number
  discount_coupon_value: number
  discount_coupon_code: string
  label_shape: string
  partial_varnish_id: number
  free_text: string
  core_diameter: number
  additional_file_copies: boolean
  additional_file_copies_delivery_id: number
  quantity_additional_file_copies: number
  force_laser_finishing: number
  // Numeric id (matching CURRENCY_IDS in client/utils/currency.ts), not set
  // for items that were added in the shop's default currency.
  currency_id?: number
  delivery_time_standard: string
  delivery_time_express: string
  diff_price: number
  cart_item_selection: ICartSelection
  cart_item_details_readable: [
    {
      property:
        | string
        | {
            en: string
            es: string
            it: string
            au: string
            us: string
          }

      value:
        | string
        | {
            en: string
            es: string
            it: string
            au: string
            us: string
          }
    }
  ]
  upload_completed: boolean
  preflight_failure_costs: number
  is_quotation?: boolean
  is_design_service?: boolean
  // REL-884: true when this cart item uses a special/custom price, so the general customer discount cannot be applied
  is_not_eligible_for_discount?: boolean
  transparency: boolean
  files?: [
    {
      customer_file_id: number
      file_name: string
    }
  ]
  blank_label_job?: boolean
  // design service cart items
  basic_fields?: {
    additional_forms: number
    high_priority: boolean
    package_type: string
    sorts: number
  }
  briefing_fields?: {
    height: string
    width: string
    label_shape: number
    project_name: string
    paper: number
    description: string
    finishing: number
    isAuthorised: boolean
  }
}

export interface ICartPayload {
  _id: string
  price: number
  tax: number
  // Always set by the API once the cart has an item — the whole cart can
  // only ever be in one currency.
  currency_id?: number
  payment_method?: number
  delivery_address_id?: number
  billing_address_id?: number
  additional_file_copies_delivery_id?: number
  voucher_set?: boolean
  voucher_unset?: boolean
  voucher_code?: string
  voucher_amount?: number
  lang?: string // Language of an evtl. error message returned by API
  account_discount?: number
  account_discount_amount?: number
  cart_items: ICartItemPayload[]
}
export interface ICartCheckoutPayload {
  order_number: string
  redirect_url: string
  _id?: string
}

export interface IAddCartItemPayload {
  _id: string
  price: number
  tax: number
}
